import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    Box,
    Button,
    CircularProgress,
    Grid,
    Tooltip,
    Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";
import { LabelCompo } from "../../components/Comman/Label";
import { redColor, titleColor } from "../../config/ColorObj";
import AttachFile from "../../components/Comman/AttachFile";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const StyledDialogTitle = styled(BootstrapDialogTitle)(({ theme }) => ({
    backgroundColor: "#F0F2F5",
    color: "#393939",
    padding: theme.spacing(1),
    fontWeight: 450,
    fontSize: "1.20rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .MuiDialogTitle-root": {
        paddingLeft: theme.spacing(5),
    },
}));

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const SelectFilePopUp = ({
    handleCloses,
    open,
    changeH,
    fileName,
    onClearHandler,
    onValidate,
    isValidating,
}) => {
    const handleClose = () => {
        handleCloses();
    };

    const onClickViewPreview = (e, row) => {
        e.stopPropagation();
        const url = URL.createObjectURL(row);
        window.open(url);
    };

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                // maxWidth="80%"
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: 2,
                        width: "80%",
                        maxWidth: "80%",
                    },
                }}
            >
                <StyledDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Import Excel Data
                </StyledDialogTitle>
                <DialogContent dividers sx={{ padding: 3, backgroundColor: "#fff" }}>
                    <Grid container xs={12} sm={12} md={12} spacing={3}>
                        <Grid item xs={12} sm={8} md={8} lg={8}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    padding: 2,
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 18, fontWeight: 500, color: "#d32f2f" }}
                                        label={"*"}
                                    />
                                    <LabelCompo
                                        className="text-black"
                                        style={{
                                            fontSize: 17,
                                            fontWeight: 450,
                                            color: "#424242",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                        label={"Select Excel File :"}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexGrow: 1,
                                        gap: 1,
                                    }}
                                >
                                    {fileName === "" ? (
                                        <AttachFile
                                            name={"file"}
                                            fileName={changeH}
                                            sx={{ flexGrow: 1 }}
                                        />
                                    ) : (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                flexGrow: 1,
                                                marginBottom: 1,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {fileName.name}
                                            </Typography>
                                            <Tooltip title="Preview File">
                                                <MyComponentWithIconProps
                                                    statusImage={VisibilityIcon}
                                                    color="primary"
                                                    fontSize="medium"
                                                    title="View"
                                                    onClick={(e) => onClickViewPreview(e, fileName)}
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "#bbdefb",
                                                            borderRadius: "50%",
                                                            padding: 1,
                                                            // paddingLeft: 10,
                                                        },
                                                    }}
                                                />
                                            </Tooltip>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                        {fileName !== "" && (
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                md={4}
                                lg={4}
                                container
                                justifyContent="flex-end"
                                alignItems="center"
                                spacing={2}
                            >
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        startIcon={<ClearIcon />}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            width: "150px",
                                            height: "35px",
                                            borderColor: "#ffcccb",
                                            color: "#d32f2f",
                                            backgroundColor: "#fff1f0",
                                            boxShadow: "0 3px 6px rgba(248, 248, 248, 0.1)",
                                            transition: "all 0.3s ease",
                                            "&:hover": {
                                                backgroundColor: "#ffe6e5",
                                                borderColor: "#d32f2f",
                                                color: "#b71c1c",
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 6px 12px rgba(248, 248, 248, 0.2)",
                                            },
                                        }}
                                        onClick={(event) => onClearHandler(event, option)}
                                    >
                                        Clear
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        startIcon={
                                            isValidating ? (
                                                <CircularProgress size={20} sx={{ color: "#fff" }} />
                                            ) : (
                                                <DoneIcon />
                                            )
                                        }
                                        disabled={isValidating}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            width: "150px",
                                            height: "35px",
                                            background:
                                                "linear-gradient(45deg, #4caf50 30%, #66bb6a 90%)",
                                            color: "#fff",
                                            boxShadow: "0 3px 6px rgba(76, 175, 80, 0.1)",
                                            transition: "all 0.3s ease",
                                            "&:hover": {
                                                background:
                                                    "linear-gradient(45deg, #388e3c 30%, #4caf50 90%)",
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 6px 12px rgba(76, 175, 80, 0.2)",
                                            },
                                            "&:disabled": {
                                                background: "#c8e6c9",
                                                color: "#fff",
                                            },
                                        }}
                                        onClick={onValidate}
                                    >
                                        {isValidating ? "Validating..." : "Validate"}
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                        {fileName === "" && <Grid item xs={12} sm={4} md={4} lg={4}></Grid>}
                    </Grid>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SelectFilePopUp);
